import {
    GET_INVOICES,
    GET_INVOICE_DETAILS,
    GET_INVOICE_STATISTICS,
    GET_INVOICES_BY_FLAT,
    GET_UNPAID_INVOICES_BY_FLAT,
    CREATE_INVOICE,
    UPDATE_INVOICE,
    UPDATE_DRAFT_INVOICE,
    DELETE_INVOICE,
    VOID_INVOICE,
    POST_INVOICE,
    CLEAR_INVOICE_STATE,
    GET_ARREARS_BY_FLAT,
    BULK_INVOICE_DETAILS,
    BULK_POST_INVOICES,
    BULK_DELETE_INVOICES,
    BULK_PREVIEW_INVOICES,
    BULK_CREATE_INVOICES
} from '../../index.types';

export function getInvoices(data) {
    return {
        type: GET_INVOICES,
        data
    }
}

export function getInvoiceDetails(data) {
    return {
        type: GET_INVOICE_DETAILS,
        data
    }
}

export function getInvoiceStatistics(data) {
    return {
        type: GET_INVOICE_STATISTICS,
        data
    }
}

export function getInvoicesByFlat(data) {
    return {
        type: GET_INVOICES_BY_FLAT,
        data
    }
}

export function getUnpaidInvoicesByFlat(data) {
    return {
        type: GET_UNPAID_INVOICES_BY_FLAT,
        data
    }
}

export function createInvoice(data) {
    return {
        type: CREATE_INVOICE,
        data
    }
}

export function updateInvoice(data) {
    return {
        type: UPDATE_INVOICE,
        data
    }
}

export function updateDraftInvoice(data) {
    return {
        type: UPDATE_DRAFT_INVOICE,
        data
    }
}

export function deleteInvoice(data) {
    return {
        type: DELETE_INVOICE,
        data
    }
}

export function voidInvoice(data) {
    return {
        type: VOID_INVOICE,
        data
    }
}

export function postInvoice(data) {
    return {
        type: POST_INVOICE,
        data
    }
}

export function clearInvoiceState() {
    return {
        type: CLEAR_INVOICE_STATE
    }
}

export function getArrearsByFlat(data) {
    return {
        type: GET_ARREARS_BY_FLAT,
        data
    }
}

export function bulkInvoiceDetails(data) {
    return {
        type: BULK_INVOICE_DETAILS,
        data
    }
}

export function bulkPostInvoices(data) {
    return {
        type: BULK_POST_INVOICES,
        data
    }
}

export function bulkDeleteInvoices(data) {
    return {
        type: BULK_DELETE_INVOICES,
        data
    }
}

export function bulkPreviewInvoices(data) {
    return {
        type: BULK_PREVIEW_INVOICES,
        data
    }
}

export function bulkCreateInvoices(data) {
    return {
        type: BULK_CREATE_INVOICES,
        data
    }
}
